import * as Styled from './WidgetArea.style';

function WidgetArea({ children }) {
  return <Styled.WidgetAreaStack>{children}</Styled.WidgetAreaStack>;
}

export default WidgetArea;
